import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { BrandLogo } from "@/components/Navbar";

const inputCls =
  "w-full h-12 rounded-xl bg-[#0d0d0d] border border-white/10 px-4 text-sm text-white placeholder:text-zinc-600 focus:border-[#FF1E27] outline-none";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/tableau" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/tableau");
    } catch (err) {
      setError(formatApiError(err, "Connexion impossible."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-4 pt-16">
      <div className="w-full max-w-md bg-[#141414] border border-white/10 rounded-2xl p-8">
        <div className="flex items-center justify-between mb-8">
          <BrandLogo />
          <span className="flex items-center gap-1.5 font-spec text-[10px] uppercase tracking-[0.25em] text-zinc-500">
            <Lock className="w-3.5 h-3.5 text-[#FF1E27]" /> Espace Pro
          </span>
        </div>
        <h1 className="font-display text-2xl font-extrabold uppercase tracking-tight mb-6">Connexion admin</h1>

        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={inputCls} autoComplete="email" />
          <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" className={inputCls} autoComplete="current-password" />
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-xl px-4 py-3">{error}</p>
          )}
          <button data-testid="admin-login-submit-btn" type="submit" disabled={loading}
            className="w-full h-12 rounded-full bg-[#FF1E27] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#E63946] transition-colors disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Se connecter
          </button>
        </form>
      </div>
    </main>
  );
}
